/**
 * The SelectVariation function is a React component that handles the selection of product variants and
 * the addition of products to the cart.
 * @returns The SelectVariation component is being returned.
 */
import React, { useEffect, useState } from "react";
import {
  CurrencySymbol,
  RELATEABLE_DIV_SHOW_ON_QUICKVIEW,
} from "../../../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import { DiscountedPriceForVariantFunc } from "../../../utils/globalFunctions/productDiscountPriceFunction";
import { globalSwalFunction } from "../../../utils/globalFunctions/globalSwal";
import ProductAttribute from "../../../pages/productView/ProductAttribute";
import { getReleatedProducts } from "../../../State/actions/ReletedProductsActions";
import { AddToCartBtnHandler } from "../../../utils/globalFunctions/cartFunctions";
import { resetSelectedProduct } from "../../../State/actions/productActions";
import PrimaryButton from "../../PrimaryButton";
import { defaultImage } from "../../../utils/productUtils/ProductUtils";

const SelectVariation = ({
  varientIndex,
  setVarientIndex,
  productVarient,
  setProductVarient,
  relatedDiv,
  triggerQuickViewModal,
  showBestQuickView,
  showProductQuickViewModal,
  showTrendingQuickView,
  setloadingOnProductQuickPage,
  productDetail,
  setProductDetail,
}) => {
  const textAlignLeft = {
    textAlign: "left",
  };
  const dispatch = useDispatch();
  const { decimalPoints, selectedProduct } = useSelector((state) => state);
  const navigate = useNavigate();

  const [showOutOfStockDiv, setShowOutOfStockDiv] = useState(false);
  const [attribute, setAttribute] = useState({
    attribute1: null,
    attribute2: null,
    attribute3: null,
  });
  const [isFromWishlist, setIsFromWishlist] = useState(false);

  const [hideButton, setHideButton] = useState(false);
  const [variantInStock, setVariantInStock] = useState(false);
  const [variantAvailablity, setVariantAvailablity] = useState("");

  let desc = "";

  /* The above code is using the `useEffect` hook in React to reset several state variables to their
 initial values when the `showBestQuickView` or `showTrendingQuickView` props change. */
  useEffect(() => {
    setVariantAvailablity("");
    setVarientIndex(0);
    setAttribute({ attribute1: null, attribute2: null, attribute3: null });
    setVariantInStock(false);
    setHideButton(true);
  }, [showProductQuickViewModal, showBestQuickView, showTrendingQuickView]);

  // The code is triggered when the "showProductQuickViewModal" state changes. It resets various state variables and clears the selected attributes of a product variant.
  useEffect(() => {
    const isFromWishlist = window.location.pathname.includes("mywishlist");
    setIsFromWishlist(isFromWishlist);
    setVariantAvailablity("");
    setVarientIndex(0);
    setAttribute({ attribute1: null, attribute2: null, attribute3: null });
    const attributes = ["attribute1", "attribute2", "attribute3"];
    attributes.forEach((attribute) => {
      const elements = document.getElementsByName(attribute);
      elements.forEach((element) => (element.checked = false));
    });
    setVariantInStock(false);
    setHideButton(true);
  }, [showProductQuickViewModal]);

  /* The code is update the state of the component based on
  changes to the selectedProduct prop. If the selectedProduct has product details, the
  loadingOnProductQuickPage state is set to false, the first product detail is set as the
  productDetail state, and a related products action is dispatched. If the selectedProduct has
  product variants, the productVarient state is set to the product variants. Finally, the
  description of the productDetail state is assigned to the desc variable. */
  useEffect(() => {
    if (selectedProduct.productdetalils.length > 0) {
      setloadingOnProductQuickPage(false);
      setProductDetail(selectedProduct.productdetalils[0]);
      dispatch(
        getReleatedProducts(selectedProduct.productdetalils[0].categoryid)
      );
    }
    if (selectedProduct.productVarient.length > 0) {
      setProductVarient(selectedProduct.productVarient);
    }
    desc = productDetail.description;
  }, [selectedProduct]);

  // The function handles adding a product to the cart, checking for attribute selection and stock availability before adding it.
  const handleAddToCart = () => {
    if (!handleAttributeSelection()) {
      globalSwalFunction(
        "PLEASE SELECT VARIATIONS !!!",
        '<i class="far fa-times-circle text-danger "></i>'
      );
      return;
    }
    if (!variantInStock) {
      globalSwalFunction(
        "Variation is Out of Stock !!!",
        '<i class="far fa-times-circle text-danger "></i>'
      );
      return;
    }
    AddToCartBtnHandler(
      productVarient[varientIndex].productvarientid,
      productVarient.length > 0 ? productVarient[varientIndex].sellingprice : 0,
      productDetail.imagepath ? productDetail.imagepath : defaultImage,
      productDetail.name,
      productVarient[varientIndex].productid,
      Number(productVarient[varientIndex].quantity),
      productVarient[varientIndex].varient,
      { activeOnline: 1 },
      dispatch
    );
    globalSwalFunction(
      `Added into Cart...!!!`,
      '<i class="fas fs-5 fa-check-circle text-success "></i>'
    );
    setHideButton(false);
  };

  /* This code uses the useEffect hook in React to check if the selected product has variants and available stock. 
  If there are variants but no stock, it sets the showOutOfStockDiv state to true.  */
  useEffect(() => {
    const hasVariants = selectedProduct?.productVarient?.length > 0;
    const hasStock = selectedProduct?.productVarient?.some(
      (productData) => productData.quantity > 0
    );
    setShowOutOfStockDiv(hasVariants &&  !variantInStock);
  }, [selectedProduct,variantInStock]);

  // The function checks if all product attributes have been selected.
  function handleAttributeSelection() {
    const { productAttributes } = selectedProduct || {};
    const { attribute1, attribute2, attribute3 } = attribute;
    switch (productAttributes?.length) {
      case 3:
        if (!attribute3) return false;
      case 2:
        if (!attribute2) return false;
      case 1:
        if (!attribute1) return false;
        break;
      default:
        return false;
    }
    return true;
  }

  // The function redirects the user to the "mycart" page after closing a quick view modal.
  const redirectToCartPage = () => {
    triggerQuickViewModal("close");
    navigate("../mycart");
  };

  // for close modal -> dispatch action for reseting the selected product state from redux.
  const closeModal = () => {
    triggerQuickViewModal("close");
    setProductDetail([]);
    setProductVarient([]);
    setloadingOnProductQuickPage(true);
    dispatch(resetSelectedProduct());
  };

  return (
    <>
      {productDetail.length !== 0 && (
        <div className="col-12 p-3">
          <div className="col-12">
            {
              <div className="Wishlistmodal-header px-0">
                <h5 className="Wishlistmodal-title" id="exampleModalLabel">
                  Available Options
                </h5>
                <PrimaryButton
                  id="modalCloseBtn"
                  type="button"
                  className="btn-close"
                  dataBsDismiss="modal"
                  ariaLabel="Close"
                  onClick={closeModal}
                />
              </div>
            }
          </div>
          {relatedDiv ==
            RELATEABLE_DIV_SHOW_ON_QUICKVIEW.ADD_PRODUCT_VARIANTS && (
            <div className="col-12" id="add_product_variant">
              <div className="d-flex w-100">
                <div className="col-sm-12 w-100" style={textAlignLeft}>
                  <div
                    className={`${
                      isFromWishlist ? "Wishlist" : "product"
                    }Card_rightSide mt-3`}
                  >
                    {!isFromWishlist && (
                      <div className="block_specification"></div>
                    )}
                    <div className="block_product col-sm-12">
                      <div className="d-flex flex-row quickview-heading">
                        <h2
                          className="block_name block_name__addName pe-2"
                          dangerouslySetInnerHTML={{
                            __html: productDetail.name,
                          }}
                        ></h2>
                      </div>
                      {/* {!isFromWishlist && (
                        <p
                          className="block_product__advantagesProduct col-sm-12"
                          dangerouslySetInnerHTML={{
                            __html: productDetail.categoryname,
                          }}
                        ></p>
                      )} */}
                      <div className="block_informationAboutDevice col-sm-12">
                        {/* {!isFromWishlist && (
                          <div className="block_descriptionInformation col-sm-12 mb-0">
                            <span>
                              {productDetail &&
                                productDetail?.shortdescription.length > 0 &&
                                productDetail?.shortdescription}
                            </span>
                          </div>
                        )} */}

                        <div className="">
                          {productVarient.length > 1 && (
                            <div
                              className="large-12 small-12 column left-align"
                              style={textAlignLeft}
                              hidden={productVarient.length > 1 ? false : true}
                            >
                              {/* {!isFromWishlist && (
                                <div className="block_price">
                                  <p className="block_price__currency">
                                    {CurrencySymbol}
                                    {productVarient.length > 0
                                      ? parseFloat(
                                          productVarient[varientIndex]
                                            .sellingprice
                                        ).toFixed(decimalPoints)
                                      : 0}
                                    {DiscountedPriceForVariantFunc(
                                      selectedProduct,
                                      varientIndex
                                    ) && (
                                      <del
                                        className="block_price__shipping"
                                        style={{
                                          fontSize: "18px",
                                          marginLeft: "10px",
                                        }}
                                      >
                                        {CurrencySymbol}
                                        {productVarient.length > 0
                                          ? parseFloat(
                                              productVarient[varientIndex].mrp
                                            ).toFixed(decimalPoints)
                                          : 0}
                                      </del>
                                    )}
                                  </p>

                                  <p className="block_price__shipping mb-0">
                                    Shipping and taxes extra
                                  </p>
                                </div>
                              )} */}
                              {productVarient.length > 1 && (
                                <>
                                  <ProductAttribute
                                    productAttributes={
                                      selectedProduct.productAttributes
                                    }
                                    setVariantAvailablity={
                                      setVariantAvailablity
                                    }
                                    setVarientIndex={setVarientIndex}
                                    setAttribute={setAttribute}
                                    setHideButton={setHideButton}
                                    setVariantInStock={setVariantInStock}
                                  />
                                  <div className="col-12">
                                    {variantAvailablity}
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                          {/* <hr className="mt-3" /> */}

                          <div
                            className="large-6 small-12 column end product_model"
                            style={{
                              marginTop: "42px",
                              textAlign: "right",
                              marginLeft: "0px",
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            <p
                              className={`${
                                isFromWishlist ? "Wishlist" : ""
                              }block_price__itemtotal`}
                            >
                              <span className="mr-2">Item total:</span> &nbsp;
                              <span
                                className="ml-2"
                                style={{ color: "var(--primary-color)" }}
                              >
                                {CurrencySymbol}
                                {productVarient.length > 0
                                  ? parseFloat(
                                      productVarient[varientIndex].sellingprice
                                    ).toFixed(decimalPoints)
                                  : 0}
                              </span>
                            </p>
                            <PrimaryButton
                              className="btn btn-secondary button button_addToCard"
                              type="button"
                              onClick={() => {
                                hideButton === true
                                  ? handleAddToCart()
                                  : redirectToCartPage();
                              }}
                              name={`${
                                hideButton === true ? "Add Item" : "Go to Cart"
                              } `}
                              disabled={showOutOfStockDiv}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SelectVariation;
